<div class="hero">
    <h1><a [routerLink]="['/']" title="Visit our HomePage">Personal Budget</a></h1>
    <h2>A personal-budget management app</h2>
</div> 